import CheckoutReRenderer from '@/app/features/Checkout/CheckoutReRenderer.vue';

import Offer from '@/app/features/Checkout/features/Offer/Offer.vue';
import OfferMobile from '@/app/features/Checkout/features/Offer/OfferMobile.vue';

import Payment from '@/app/features/Checkout/features/Payment/Payment.vue';
import PaymentMobile from '@/app/features/Checkout/features/Payment/PaymentMobile.vue';

import Login from '@/app/features/Customer/features/Login/Login.vue';
import Register from '@/app/features/Customer/features/Register/Register.vue';

import { ENavigationGuardTypes, ECheckoutStep } from '@/helpers/enums';

export default [
  {
    path: '/:slug',
    component: CheckoutReRenderer,
    meta: {
      checkoutStep: ECheckoutStep.none,
      navigationGuardType: ENavigationGuardTypes.public,
    },
    children: [
      {
        name: 'checkout',
        path: '',
        components: {
          left: Offer,
          right: Login,
          mobile: OfferMobile,
        },
        meta: {
          checkoutStep: ECheckoutStep.authentication,
          navigationGuardType: ENavigationGuardTypes.authentication,
        },
      },
      {
        name: 'register',
        path: 'cadastro',
        components: {
          left: Offer,
          right: Register,
          mobile: OfferMobile,
        },
        meta: {
          checkoutStep: ECheckoutStep.authentication,
          navigationGuardType: ENavigationGuardTypes.authentication,
        },
      },
      {
        name: 'payment',
        path: 'pagamento',
        components: {
          left: Offer,
          right: Payment,
          mobile: PaymentMobile,
        },
        meta: {
          checkoutStep: ECheckoutStep.payment,
          navigationGuardType: ENavigationGuardTypes.private,
        },
      },
      {
        name: 'renew',
        path: 'renovar',
        components: {
          left: Offer,
          right: Payment,
          mobile: PaymentMobile,
        },
        meta: {
          checkoutStep: ECheckoutStep.payment,
          navigationGuardType: ENavigationGuardTypes.private,
        },
      },
    ],
  },
];
